import { useToast } from '@airship-platform/airship-patterns';
import { CopyIcon } from '@airship-platform/jam-web/icons';
import Button from '@mui/material/Button';

interface OwnProps {
  getMessageBody: () => Promise<string | null>;
  loading: boolean;
}

const CopyMessageButton: React.FC<OwnProps> = ({ getMessageBody, loading }) => {
  const { showToast } = useToast();

  const handleCopy = async () => {
    const body = await getMessageBody();

    if (!body) {
      return;
    }

    try {
      await navigator.clipboard.writeText(body);
      showToast('Message and proposal link copied', 'success');
    } catch {
      showToast('We were unable to copy the message', 'warning');
    }
  };

  return (
    <Button
      color={'softGold'}
      startIcon={<CopyIcon />}
      onClick={handleCopy}
      loading={loading}
    >
      Copy
    </Button>
  );
};

export default CopyMessageButton;
